import React, { useState } from "react";
import { FormControl, IconButton, InputLabel, Select, TableCell, TextField } from "@material-ui/core";
import { MountRequirement } from "models/managed/mount-requirement";
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';


interface Props {
    mountReq: MountRequirement,
    updateMountReq: (newMountReq: MountRequirement) => void,
    cancelEdit: () => void,
    toggleEdit: React.Dispatch<React.SetStateAction<boolean>>,
    setEdits: React.Dispatch<React.SetStateAction<MountRequirement>>,
    isEditing?: boolean,
    addMountReq: (newMountReq: MountRequirement) => void
}

const MountReqForm: React.FC<Props> = (props) => {

    const [inputs, setInputs] = useState(new MountRequirement(props.mountReq.description || "", props.mountReq.source || "", props.mountReq.target || ""));

    const handleChange = (event: any) => {
        const {name, value} = event.target;
        setInputs(prevInputs => ({...prevInputs, [name]: value}));
    }

    const handleSubmit = () => {
        if(props.isEditing){
        props.setEdits(inputs);
        props.updateMountReq(inputs);
        setInputs(new MountRequirement("", "", ""));
        props?.toggleEdit(false); 
        } else {
            props.addMountReq(inputs);
        }
    }

    const onCancel = () => {
        if(props.isEditing){
            props.cancelEdit();
        } 
    }
    
    return(
        <>
        <TableCell style={{ width: '150px' }}>
            <TextField
                required
                autoFocus={false}
                name="target"
                fullWidth
                value={inputs.target}
                margin="dense"
                id="messsageArg"
                onChange={handleChange}
                // onChange={(event: any) => { setEditedValue(new MountRequirement(parseInt(event.target.value), inputs.description, editedValue.protocol)); }}
            />
        </TableCell>
            <TextField
                required
                autoFocus={false}
                name="description"
                fullWidth
                value={inputs.description}
                margin="dense"
                id="messsageArg"
                onChange={handleChange}
                // onChange={(event: any) => { setEditedValue(new MountRequirement(parseInt(event.target.value), inputs.description, editedValue.protocol)); }}
            />
        <TableCell style={{ width: '200px' }}>
            <TextField
                required
                name="source"
                autoFocus={false}
                fullWidth
                value={inputs.source}
                margin="dense"
                id="messsageArg"
                onChange={handleChange}
                // onChange={(event: any) => { setEditedValue(new MountRequirement(editedValue.containerMount, event.target.value, editedValue.protocol)); }}
            />
        </TableCell>
        <TableCell style={{ width: '100px' }}>
            <IconButton size="small" onClick={() => handleSubmit()}>
                <CheckIcon />
            </IconButton>
            <IconButton size="small" onClick={() => { onCancel(); }}>
                <CancelIcon />
            </IconButton>
        </TableCell>
</>
    );
}

export default MountReqForm;